// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --table-spacing: 0.3rem;
}

.payout-structures_payoutStructureTableCell__onqDu {
  background-color: #212529;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.payout-structures_oddColumn__T\\+XKI {
  filter: brightness(1.4);
}

.payout-structures_jsonInputTextArea__8XO5U {
  min-height: 400px;
  height: 400px;
}

.payout-structures_payoutStructureTableInputCell__vVLCV {
  width: 100%;
  height: 100%;
  border: 1px solid transparent;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;

  background-color: #212529;

  &:hover {
    font-weight: bold;
    border-color: #cccccc;
    cursor: pointer;
  }

  &:focus {
    border-color: #e6e6e6;
    font-weight: bold;
  }
}

.payout-structures_payoutStructureTableInputCellIncomplete__O22XJ {
  background-color: transparent !important;
  border-color: transparent !important;
}

.payout-structures_tableFooterCellButton__WcQMQ {
  width: 100%;
  height: 100%;
  opacity: 0.25;
  &:hover {
    opacity: 1;
  }
}

.payout-structures_showOnHover__NidO9 {
  opacity: 0.25;

  &:hover {
    opacity: 1;
  }
}

.payout-structures_deleteRowButton__VD1cz {
  width: 100%;
  height: 100%;
  opacity: 0.25;

  &:hover {
    opacity: 1;
  }
}

.payout-structures_payoutStructureTableInputCellDisabled__i\\+Do9 {
  visibility: hidden;
}

.payout-structures_tableCellContainer__E4vo6 {
  position: relative;
  width: 100%;
  height: 100%;
}

.payout-structures_createNewColumnButton__dgkDl {
  margin-left: 3px;

  opacity: 0.25;
  &:hover {
    opacity: 1;
  }
}

.payout-structures_payoutStructureTableInputCellEmpty__n2Cjf {
  border: 1px solid transparent;
  background-color: transparent;
  color: #808080;

  &:hover {
    border: 1px dashed #808080;
    color: #808080;
    cursor: pointer;
  }

  &:focus {
    color: white;
    border: 1px solid white;
  }
}

.payout-structures_payoutStructureTableHeaderCellContainer__dulqg {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
}

.payout-structures_invalidCell__znHFF {
  color: #b30000;
  background-color: rgb(179, 0, 0, 0.1);
}

.payout-structures_percentageComplete__cwRQi {
  background-color: #283930;
  color: #17b26a;
}

.payout-structures_percentageIncomplete__LqExS {
  background-color: #b30000;
  color: #e60000;
}

.payout-structures_payoutStructureFormTableBody__xaoXU {
  padding-top: 0.3rem;
  padding-top: var(--table-spacing);
}

/* Virtualized Table Styles */
.payout-structures_virtualizedTableContainer__sZVM0 {
  position: relative;
  width: 100%;
}

.payout-structures_cornerHeaderCell__ZjtTl {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #212529;
  border: 1px solid transparent;
  border-radius: 2px;
  color: #6c757d;
  font-size: 14px;
  text-align: center;
}

.payout-structures_addRowButtonFixed__uS2aq {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  background-color: #1a1d21;
}

.payout-structures_addRowButtonCell__fAG55 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payout-structures_addColumnButton__I5c5S,
.payout-structures_addRowButton__gYvf5 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 100%;
  width: 100%;
}

.payout-structures_rangeInput__936Po {
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #2c3136;
  border: 1px solid #495057;
  color: white;
  padding: 2px;
  font-size: 12px;
}

.payout-structures_rangeInput__936Po:focus {
  border-color: #0d6efd;
  outline: none;
}

/* Single Scroll Container with Sticky Elements */
.payout-structures_singleScrollContainer__umReX {
  position: relative;
  overflow: auto;
  background-color: #1a1d21;
}

.payout-structures_stickyCornerHeader__MZ3xC {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 20;
  background-color: #212529;

  display: flex;
  flex-direction: column;
}

.payout-structures_stickyColumnHeaders__JU5AV {
  background-color: #1a1d21;
  border-bottom: 1px solid #343a40;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  height: 100%;
}

.payout-structures_stickyColumnHeader__c6lfX {
  position: absolute;
  top: 0;
  background-color: #212529;
  border-right: 1px solid #343a40;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payout-structures_stickyAddColumnButton__Qaoaa {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 15;
  background-color: #1a1d21;
  border-bottom: 1px solid #343a40;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payout-structures_stickyRowHeaders__6oP2T {
  background-color: #1a1d21;
}

.payout-structures_stickyRowHeader__znPEC {
  background-color: #212529;
  border-right: 1px solid #343a40;
  border-bottom: 1px solid #343a40;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payout-structures_stickyRemoveButtons__g8Ior {
  position: -webkit-sticky;
  position: sticky;
  right: 0;
  z-index: 10;
  background-color: #1a1d21;
}

.payout-structures_stickyRemoveButton__UME9- {
  position: absolute;
  top: 0;
  background-color: #212529;
  border-left: 1px solid #343a40;
  border-bottom: 1px solid #343a40;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payout-structures_mainDataGrid__sDoH9 {
  position: absolute;
  background-color: #1a1d21;
}

.payout-structures_dataCell__SwZCz {
  position: absolute;
  top: 0;
  left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tournaments/PayoutStructures/payout-structures.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;;EAE7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,yBAAyB;;EAEzB;IACE,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;AACF;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;;EAEb;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;;EAEhB,aAAa;EACb;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;;EAEd;IACE,0BAA0B;IAC1B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAiC;EAAjC,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,WAAW;EACX,yBAAyB;;EAEzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;;EAEhC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;;EAEvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT","sourcesContent":[":root {\n  --table-spacing: 0.3rem;\n}\n\n.payoutStructureTableCell {\n  background-color: #212529;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.oddColumn {\n  filter: brightness(1.4);\n}\n\n.jsonInputTextArea {\n  min-height: 400px;\n  height: 400px;\n}\n\n.payoutStructureTableInputCell {\n  width: 100%;\n  height: 100%;\n  border: 1px solid transparent;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  text-align: center;\n\n  background-color: #212529;\n\n  &:hover {\n    font-weight: bold;\n    border-color: #cccccc;\n    cursor: pointer;\n  }\n\n  &:focus {\n    border-color: #e6e6e6;\n    font-weight: bold;\n  }\n}\n\n.payoutStructureTableInputCellIncomplete {\n  background-color: transparent !important;\n  border-color: transparent !important;\n}\n\n.tableFooterCellButton {\n  width: 100%;\n  height: 100%;\n  opacity: 0.25;\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.showOnHover {\n  opacity: 0.25;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.deleteRowButton {\n  width: 100%;\n  height: 100%;\n  opacity: 0.25;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.payoutStructureTableInputCellDisabled {\n  visibility: hidden;\n}\n\n.tableCellContainer {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.createNewColumnButton {\n  margin-left: 3px;\n\n  opacity: 0.25;\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.payoutStructureTableInputCellEmpty {\n  border: 1px solid transparent;\n  background-color: transparent;\n  color: #808080;\n\n  &:hover {\n    border: 1px dashed #808080;\n    color: #808080;\n    cursor: pointer;\n  }\n\n  &:focus {\n    color: white;\n    border: 1px solid white;\n  }\n}\n\n.payoutStructureTableHeaderCellContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.invalidCell {\n  color: #b30000;\n  background-color: rgb(179, 0, 0, 0.1);\n}\n\n.percentageComplete {\n  background-color: #283930;\n  color: #17b26a;\n}\n\n.percentageIncomplete {\n  background-color: #b30000;\n  color: #e60000;\n}\n\n.payoutStructureFormTableBody {\n  padding-top: var(--table-spacing);\n}\n\n/* Virtualized Table Styles */\n.virtualizedTableContainer {\n  position: relative;\n  width: 100%;\n}\n\n.cornerHeaderCell {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #212529;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  color: #6c757d;\n  font-size: 14px;\n  text-align: center;\n}\n\n.addRowButtonFixed {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0;\n  background-color: #1a1d21;\n}\n\n.addRowButtonCell {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.addColumnButton,\n.addRowButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  height: 100%;\n  width: 100%;\n}\n\n.rangeInput {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background-color: #2c3136;\n  border: 1px solid #495057;\n  color: white;\n  padding: 2px;\n  font-size: 12px;\n}\n\n.rangeInput:focus {\n  border-color: #0d6efd;\n  outline: none;\n}\n\n/* Single Scroll Container with Sticky Elements */\n.singleScrollContainer {\n  position: relative;\n  overflow: auto;\n  background-color: #1a1d21;\n}\n\n.stickyCornerHeader {\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 20;\n  background-color: #212529;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.stickyColumnHeaders {\n  background-color: #1a1d21;\n  border-bottom: 1px solid #343a40;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n\n  height: 100%;\n}\n\n.stickyColumnHeader {\n  position: absolute;\n  top: 0;\n  background-color: #212529;\n  border-right: 1px solid #343a40;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stickyAddColumnButton {\n  position: sticky;\n  top: 0;\n  z-index: 15;\n  background-color: #1a1d21;\n  border-bottom: 1px solid #343a40;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stickyRowHeaders {\n  background-color: #1a1d21;\n}\n\n.stickyRowHeader {\n  background-color: #212529;\n  border-right: 1px solid #343a40;\n  border-bottom: 1px solid #343a40;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stickyRemoveButtons {\n  position: sticky;\n  right: 0;\n  z-index: 10;\n  background-color: #1a1d21;\n}\n\n.stickyRemoveButton {\n  position: absolute;\n  top: 0;\n  background-color: #212529;\n  border-left: 1px solid #343a40;\n  border-bottom: 1px solid #343a40;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mainDataGrid {\n  position: absolute;\n  background-color: #1a1d21;\n}\n\n.dataCell {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"payoutStructureTableCell": `payout-structures_payoutStructureTableCell__onqDu`,
	"oddColumn": `payout-structures_oddColumn__T+XKI`,
	"jsonInputTextArea": `payout-structures_jsonInputTextArea__8XO5U`,
	"payoutStructureTableInputCell": `payout-structures_payoutStructureTableInputCell__vVLCV`,
	"payoutStructureTableInputCellIncomplete": `payout-structures_payoutStructureTableInputCellIncomplete__O22XJ`,
	"tableFooterCellButton": `payout-structures_tableFooterCellButton__WcQMQ`,
	"showOnHover": `payout-structures_showOnHover__NidO9`,
	"deleteRowButton": `payout-structures_deleteRowButton__VD1cz`,
	"payoutStructureTableInputCellDisabled": `payout-structures_payoutStructureTableInputCellDisabled__i+Do9`,
	"tableCellContainer": `payout-structures_tableCellContainer__E4vo6`,
	"createNewColumnButton": `payout-structures_createNewColumnButton__dgkDl`,
	"payoutStructureTableInputCellEmpty": `payout-structures_payoutStructureTableInputCellEmpty__n2Cjf`,
	"payoutStructureTableHeaderCellContainer": `payout-structures_payoutStructureTableHeaderCellContainer__dulqg`,
	"invalidCell": `payout-structures_invalidCell__znHFF`,
	"percentageComplete": `payout-structures_percentageComplete__cwRQi`,
	"percentageIncomplete": `payout-structures_percentageIncomplete__LqExS`,
	"payoutStructureFormTableBody": `payout-structures_payoutStructureFormTableBody__xaoXU`,
	"virtualizedTableContainer": `payout-structures_virtualizedTableContainer__sZVM0`,
	"cornerHeaderCell": `payout-structures_cornerHeaderCell__ZjtTl`,
	"addRowButtonFixed": `payout-structures_addRowButtonFixed__uS2aq`,
	"addRowButtonCell": `payout-structures_addRowButtonCell__fAG55`,
	"addColumnButton": `payout-structures_addColumnButton__I5c5S`,
	"addRowButton": `payout-structures_addRowButton__gYvf5`,
	"rangeInput": `payout-structures_rangeInput__936Po`,
	"singleScrollContainer": `payout-structures_singleScrollContainer__umReX`,
	"stickyCornerHeader": `payout-structures_stickyCornerHeader__MZ3xC`,
	"stickyColumnHeaders": `payout-structures_stickyColumnHeaders__JU5AV`,
	"stickyColumnHeader": `payout-structures_stickyColumnHeader__c6lfX`,
	"stickyAddColumnButton": `payout-structures_stickyAddColumnButton__Qaoaa`,
	"stickyRowHeaders": `payout-structures_stickyRowHeaders__6oP2T`,
	"stickyRowHeader": `payout-structures_stickyRowHeader__znPEC`,
	"stickyRemoveButtons": `payout-structures_stickyRemoveButtons__g8Ior`,
	"stickyRemoveButton": `payout-structures_stickyRemoveButton__UME9-`,
	"mainDataGrid": `payout-structures_mainDataGrid__sDoH9`,
	"dataCell": `payout-structures_dataCell__SwZCz`
};
export default ___CSS_LOADER_EXPORT___;
